import React, {Component} from 'react';
import PropTypes from 'prop-types';
import DealerBox from './DealerBox';
import Grid from 'material-ui/Grid';
import * as firebase from 'firebase';
import Table, { TableBody, TableCell, TableHead, TableRow } from 'material-ui/Table';

/**
 * Receives sessionid and uid props from simulationContainer
 *
 * this component acts as the simulationContainer for all
 * components in the actual orderbook.
 */
class DealerColumn extends Component {
    constructor(props) {
        //console.log("OrderbookContainer created");
        super(props);
    }

    componentDidMount() {

    }

    componentWillUnmount() {
    }

    /**
     * Conditionally renders limit orders based on state.ready
     * @returns {*}
     */
    render() {
        //console.log("OrderbookContainer render");
        //console.log(this.state.userSums);
        return (
            <Grid className="dealerColumnStyle" item xs={6}>
              {this.props.players.map(player=>{
                return (
                  <DealerBox  
                  institution={this.props.institution}
                  paused={false}
                  uid={this.props.uid}
                  db={this.props.db}
                  sessionid={this.props.sessionid}
                  columnType={this.props.columnType} 
                  player={player}
                  solo = {this.props.solo} 
                  creator = {this.props.creator}
                  />
                );
              })}
            </Grid>
        );
    }
}

export default DealerColumn;



// WEBPACK FOOTER //
// ./src/components/Orderbook/DealerColumn.js